import * as React from 'react';
import { Component } from 'react';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/styles/withStyles';
import WoeUserLookupDataViewModel from '../ViewModels/WoeUserLookupDataViewModel';
import DocumentUploadLogin from './DocumentUploadLogin';
import DocumentUploadTypeSelection from './DocumentUploadTypeSelection';
import DocumentUploadPhoto  from './DocumentUploadPhoto';
import DocumentUploadPhotoConfirmation from './DocumentUploadPhotoConfirmation';
import DocumentUploadPhotoSubmitted from './DocumentUploadPhotoSubmitted';
import DocumentUploadDocument from './DocumentUploadDocument';
import DocumentUploadBasket from './DocumentUploadBasket';
import DocumentViewModel from '../ViewModels/DocumentViewModel';
import DocumentUploadSubmitConfirmed from './DocumentUploadSubmitConfirmed';
import DocumentUploadPhotoUploadMobileSafari from './DocumentUploadPhotoUploadMobileSafari';

const styles = (theme: Theme) => createStyles({
    root: {
        flexGrow: 1,
        zIndex: 1,
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
});

interface IDocumentUploadProps {
}

interface IDocumentUploadState {
    model: WoeUserLookupDataViewModel | undefined;
    documentType: number | undefined;
    documentTypeText: string | undefined;
    photo: File | undefined;
    photoSubmited: boolean;
    documents: DocumentViewModel[];
    currDocumentUploaded: boolean;
    documentsSubmited: boolean;
    photoSubmitedViewBasket: boolean;
}

export class DocumentUpload extends Component<IDocumentUploadProps & WithStyles<typeof styles>, IDocumentUploadState> {
    constructor(props) {
        super(props);

        this.state = {
            model: undefined,
            documentType: undefined,
            documentTypeText: undefined,
            photo: undefined,
            photoSubmited: false,
            documents: [],
            currDocumentUploaded: false,
            documentsSubmited: false,
            photoSubmitedViewBasket: false
        };
    }

    public componentDidMount() {
    }

    public isMobileSafari = () => {
        return navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)
    }

    public render() {

        return (
            <React.Fragment>
                {this.state.model === undefined ?
                    <DocumentUploadLogin setModel={this.setModel} />
                    :
                    this.state.documentType === undefined ?
                        <DocumentUploadTypeSelection setDocType={this.setDocType} />
                        :
                        this.state.documentType === 9 && !this.isMobileSafari() ?
                            this.state.photo === undefined ?
                                <DocumentUploadPhoto setPhoto={this.setPhoto} photo={this.state.photo} clearDocType={this.clearDocType} />
                                :
                                this.state.photoSubmited === false ?
                                    <DocumentUploadPhotoConfirmation setPhoto={this.setPhoto} photo={this.state.photo} setPhotoSubmited={this.setPhotoSubmited} />
                                    :
                                    this.state.photoSubmitedViewBasket === false ?
                                        <DocumentUploadPhotoSubmitted returnToDocType={this.returnToDocTypeSelection} basketDocumentCount={this.state.documents === undefined ? 0 : this.state.documents.length} viewBasket={this.viewBasket}/>
                                        :
                                        this.state.documentsSubmited === false ?
                                            <DocumentUploadBasket documents={this.state.documents} removeDocument={this.removeDocument} uploadAnotherDocument={this.returnToDocTypeSelection} submitDocuments={this.submitDocuments} />
                                            :
                                            <DocumentUploadSubmitConfirmed />
                            :
                            this.state.documentType === 9 && this.isMobileSafari ?
                                <DocumentUploadPhotoUploadMobileSafari returnToDocType={this.returnToDocTypeSelection} viewBasket={this.viewBasket}/>
                            :
                            this.state.currDocumentUploaded === false ?
                                <DocumentUploadDocument dialogOpen={true} closeDialog={this.returnToDocTypeSelection} submit={this.addCurrentDocument} />
                                :
                                this.state.documentsSubmited === false ?
                                    <DocumentUploadBasket documents={this.state.documents} removeDocument={this.removeDocument} uploadAnotherDocument={this.returnToDocTypeSelection} submitDocuments={this.submitDocuments}/>
                                    :
                                    <DocumentUploadSubmitConfirmed />
                }
            </React.Fragment>
        );
    }

    private setModel = (newModel) => {
        this.setState({ model: newModel });
    }

    private setDocType = (value: number, text: string) => {
        this.setState({ documentType: value, documentTypeText: text });
    }

    private setPhoto = (photo: Promise<File>) => {
        if (photo === undefined) {
            this.setState({ photo: undefined});
        } else {
            //newModel.photo = photo;
            photo.then((data) => {
                this.setState({ photo: data });
            });
        }
    }

    private clearDocType = () => {
        this.setState({ documentType: undefined });
    }

    private returnToDocTypeSelection = () => {
        this.setState({
            documentType: undefined,
            photo: undefined,
            photoSubmited: false,
            currDocumentUploaded: false,
            documentTypeText: undefined,
        });
    }

    private addCurrentDocument = (document: File) => {
        let newDoc = new DocumentViewModel;
        newDoc.document = document;
        newDoc.documentType = this.state.documentType;
        newDoc.documentTypeText = this.state.documentTypeText;
        console.log(newDoc);

        let currDocuments = this.state.documents;
        if (currDocuments.length) {
            currDocuments.push(newDoc);
        } else {
            currDocuments = [newDoc];
        }

        this.setState({
            documents: currDocuments,
            currDocumentUploaded: true
        });
    }

    private removeDocument = (document: DocumentViewModel) => {
        let currDocuments = this.state.documents;
        currDocuments.splice(currDocuments.indexOf(document), 1);
        this.setState({ documents: currDocuments });
    }

    private submitDocuments = () => {
        //let documents = JSON.stringify(this.state.documents);

        if (this.state.documents.length && this.state.model?.refNo !== undefined && this.state.model.dateOfBirth !== undefined && this.state.model.postcodeOut !== undefined && this.state.model.postcodeIn !== undefined && this.state.model?.academicYearId !== undefined && this.state.model?.studentId !== undefined) {
            let formData: FormData = new FormData();
            this.state.documents.forEach(document => {
                if (document.document !== undefined && document.documentType !== undefined && document.documentTypeText !== undefined) {
                    formData.append('documents', document.document);
                    formData.append('documentTypes', document.documentType.toString());
                    formData.append('documentTypeTexts', document.documentTypeText);
                }
            })
            //[FromForm] string RefNo, [FromForm] DateTime dateOfBirth, [FromForm] string PostCode
            formData.append('RefNo', this.state.model?.refNo);
            formData.append('DateOfBirth', new Date(this.state.model?.dateOfBirth.toString()).toUTCString());
            formData.append('PostCode', this.state.model?.postcodeOut + ' ' + this.state.model?.postcodeIn);
            formData.append('AcademicYear', this.state.model?.academicYearId);
            formData.append('StudentId', this.state.model?.studentId.toString());

            fetch('api/DocumentUpload/SaveDocuments', {
                method: 'POST',
                body: formData
            }).then((data) => {
                this.setState({ documentsSubmited: true });
            });
        }
    }

    private setPhotoSubmited = (allowUseForMarketing: boolean) => {
        if (this.state.photo !== undefined && this.state.model?.refNo !== undefined && this.state.model.dateOfBirth !== undefined && this.state.model.postcodeOut !== undefined && this.state.model.postcodeIn !== undefined && this.state.model?.academicYearId !== undefined && this.state.model?.studentId !== undefined) {
            let formData: FormData = new FormData();

            formData.append('Photo', this.state.photo);
            formData.append('RefNo', this.state.model?.refNo);
            formData.append('DateOfBirth', new Date(this.state.model?.dateOfBirth.toString()).toUTCString());
            formData.append('PostCode', this.state.model?.postcodeOut + ' ' + this.state.model?.postcodeIn);
            formData.append('AcademicYear', this.state.model?.academicYearId);
            formData.append('StudentId', this.state.model?.studentId.toString());
            formData.append('AllowUseForMarketing', allowUseForMarketing.toString());

            fetch('api/DocumentUpload/SavePhoto', {
                method: 'POST',
                body: formData
            }).then((data) => {
                this.setState({ photoSubmited: true });
            });
        }
    }

    private viewBasket = () => {
        this.setState({ photoSubmitedViewBasket: true });
    }
}

export default withStyles(styles)(DocumentUpload);

